/**
 * @generated SignedSource<<121e2ad272fd71c7e69a9930dfe28d31>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type InlineNewsletterSignupMutation$variables = {
  email: string;
  recaptcha: string;
};
export type InlineNewsletterSignupMutation$data = {
  readonly signupEmailNewsletter: {
    readonly result: boolean | null;
  } | null;
};
export type InlineNewsletterSignupMutation = {
  response: InlineNewsletterSignupMutation$data;
  variables: InlineNewsletterSignupMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "email"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "recaptcha"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "email",
        "variableName": "email"
      },
      {
        "kind": "Variable",
        "name": "recaptcha",
        "variableName": "recaptcha"
      }
    ],
    "concreteType": "SignupEmailNewsletter",
    "kind": "LinkedField",
    "name": "signupEmailNewsletter",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "result",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "InlineNewsletterSignupMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "InlineNewsletterSignupMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "552ab7c2372cfdf00b5a1f3d27014dcd",
    "id": null,
    "metadata": {},
    "name": "InlineNewsletterSignupMutation",
    "operationKind": "mutation",
    "text": "mutation InlineNewsletterSignupMutation(\n  $email: String!\n  $recaptcha: String!\n) {\n  signupEmailNewsletter(email: $email, recaptcha: $recaptcha) {\n    result\n  }\n}\n"
  }
};
})();

(node as any).hash = "35b2af7602972892c03494fa1ff1f9f8";

export default node;
